<div class="page">
  <div class="menu-setting">
    <div class="menu-setting-title">
      <h1>{{ "ClientApp.FrontOffice.Portal.MenuSetting.MenuSettings" | translate }}</h1>
      <button (click)="saveMenuSetting()">{{ "ClientApp.FrontOffice.Portal.MenuSetting.SaveSettings" | translate }}</button>
    </div>

    <div class="social-media" *ngIf="formGroup">
      <div class="logo-uploader">
        <div class="logo-image">
          <img [src]="model.Logo ? model.Logo : 'assets/images/system-logo.png'" alt="" />
        </div>
        <input #logoInput type="file" (change)="uploadLogo($event)" accept="image/png/jpeg/jpg" />
        <button (click)="logoInput.click()">{{ "ClientApp.FrontOffice.Portal.MenuSetting.UploadLogo" | translate }}</button>
      </div>
      <div class="col-lg-4">
        <ssg-checkbox
          name="showAllCategories"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Portal.MenuSetting.ShowAllCategoriesButton' | translate"
          [required]="false"
          disabled="false"
          textType="text">
        </ssg-checkbox>
      </div>
      <div class="d-flex flex-wrap">
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="instagram"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.Instagram' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="telegram"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.Telegram' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="twitter"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.Twitter' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="facebook"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.Facebook' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="whatsApp"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.WhatsApp' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
        <div class="col-md-4 col-lg-3">
          <ssg-input
            name="website"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Portal.MenuSetting.website' | translate"
            [required]="false"
            disabled="false"
            textType="text"></ssg-input>
        </div>
      </div>
    </div>
  </div>
</div>
